import React, { Children } from 'react';
import styled from 'styled-components';
import { BG } from '../../styles/color';
import Footer from './Footer';

const Body = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 110px;
    width: 100%;
    min-width: 1080px;
    background-color: ${ BG.light01 };
    padding-bottom: 180px;
`;

export default function MainBody(props) {
  return (
    <Body>
      {props.children}
      <Footer/>
    </Body>
  )
}